/*-----------------------------------------------------------------
- Products Rate
-----------------------------------------------------------------*/
export default {
    rate_count   : 'از {count} رای',
    rate_title   : 'به این محصول امتیاز دهید',
    rate_subtitle: 'امتیاز شما در بهبود کیفیت محصولات ما اثرگذار است',
    login        : 'برای ثبت امتیاز، ابتدا وارد شوید.',
    success      : 'امتیاز شما با موفقیت ثبت شد.',
};
